module.exports = __webpack_public_path__ + "img/hero_4.a59266fc.webp";